require('./cardChargeAccountFullStep.scss');

const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @components
const WizardError = require('components/commons/wizardError/wizardError');

// @commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @constants
const language = getLanguage();

const CardChargeAccountFullStep = props => {
    const { immCard, amount } = props;
    const title = formatText('moneyRequestView-accountFullTitle');
    const cardAlias = immCard.getIn(['alias', 'current']);
    const goBackButtonLabel = formatText('cardChargeError-backToCard', [cardAlias]).toUpperCase();
    const linkToMovements = `/myprofile/cards/${immCard.get('cardId')}/movements`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToMovements
    }

    const currency = immCard.getIn(['availableBalance', 'currency']);
    const amountObject = {amount, currency};
    const plainAmountObject = getPlainAmountObject(amountObject);

    return (
        <div className="col-xs-12 col-md-offset-2 col-md-8 card-charge-account-full">
            <WizardError
                errorMessage={title}
                mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-7">
                        <FormattedText value="moneyRequestView-accountFullContent" />
                        <div className="card-charge-account-full__content">
                            <FormattedText value="cardCharge-amount" />
                            <div>
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    className="card-charge-account-full__balance"
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </WizardError>
        </div>
    )
};

CardChargeAccountFullStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    amount: PropTypes.number.isRequired
};

module.exports = CardChargeAccountFullStep;
